import { DocTypes } from '../static/Assumptions';
import { Injectable } from '@angular/core';

export interface UploadSettings {
  MaxUploads: number;
  RequiredDocumentType: DocTypes;
}

@Injectable()
export class RequiredDocumentsService {
  public GetUploadSettings(): UploadSettings {
    //Replace with DB call to grab requirement that failed the previous WorkFlow stage
    const failedRequirement = '';

    const uploadSettings: UploadSettings = {
      MaxUploads: RequiredDocumentConfig[failedRequirement].MaxUploads,
      RequiredDocumentType: RequiredDocumentConfig[failedRequirement].DocType,
    };

    return uploadSettings;
  }
}

const RequiredDocumentConfig = {
  '': {
    MaxUploads: 4,
    DocType: DocTypes.CustomerUpload,
  },
};
